import {Component, Injector, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {LandingModelService} from "../../services/landingModel.service";
import {LandingModel} from "../../model/landingModel";
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';

@Component({
    selector: 'covid',
    template: `
        <div class="covid-container">
            <covid-map *ngIf="module.data.map" [lang]="landingModel.language" (onLoad)="onComponentLoad()"></covid-map>
            <covid-search *ngIf="module.data.search" [lang]="landingModel.language" (onLoad)="onComponentLoad()"></covid-search>
            <loader *ngIf="!loaded" product="nymeria-gui" [flow]="flow"></loader>
        </div>
    `,
    styleUrls: ['./covid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CovidComponent extends AbstractComponent implements OnInit {
    public static MODULE_ID: string = 'CovidModule';
    @Input() override module: Module<CovidData>;
    @Input() override product;
    @Input() override flow;
    
    landingModel: LandingModel;
    loaded: boolean = false;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.landingModel = this.landingModelService.getLandingModel();
    }

    onComponentLoad = () => {
        this.loaded = true;
    }

    getModuleId(): string {
        return CovidComponent.MODULE_ID;
    }
}

interface CovidData {
    map: boolean;
    search: boolean;
}
